import React from "react";
import { LatLngLike } from "../types/mapData";

const ZoomBox = ({
  map,
  setCenter,
  viewCenter,
  isMobile,
}: {
  map: google.maps.Map;
  setCenter: (
    latlng: LatLngLike | null,
    offset?: "negative" | "offset",
  ) => void;
  viewCenter: LatLngLike | null;
  isMobile: boolean;
}) => {
  function handleZoom(which: number) {
    map.setZoom(map.getZoom() + which);
  }

  return (
    <div className={`zoom-box ${isMobile ? "zoom-box-mobile" : ""}`}>
      <div
        className="zoom-in"
        onClick={() => {
          handleZoom(1);
          !!viewCenter
            ? setCenter(viewCenter)
            : setCenter(viewCenter, "negative");
        }}
      >
        +
      </div>
      <div
        className="zoom-out"
        onClick={() => {
          handleZoom(-1);
          !!viewCenter
            ? setCenter(viewCenter)
            : setCenter(viewCenter, "offset");
        }}
      >
        -
      </div>
    </div>
  );
};

export default ZoomBox;
